import { scoreColor } from '@workspace/seedforge-shared'
import { cn } from '@workspace/ui/lib/utils'
import type { ReactNode } from 'react'

export interface EvaluationHeaderProps {
  title: string
  sessionLabel: string
  date: string
  pitchDuration: string
  score?: number | null
  action?: ReactNode
}

export function EvaluationHeader({
  title,
  sessionLabel,
  date,
  pitchDuration,
  score,
  action,
}: EvaluationHeaderProps) {
  return (
    <div className="flex items-start justify-between gap-4">
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-3">
          <h1 className="text-2xl font-semibold tracking-tight text-foreground">{title}</h1>
          <span className="rounded-full border border-[#f97316]/20 bg-[#f97316]/10 px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-[#f97316]">
            {sessionLabel}
          </span>
          {score != null && (
            <span className={cn('text-2xl font-bold tabular-nums', scoreColor(score))}>
              {score}
              <span className="text-sm font-normal text-muted-foreground/50">/100</span>
            </span>
          )}
        </div>
        <p className="mt-1.5 flex items-center gap-2 text-xs text-muted-foreground/80">
          <span>{date}</span>
          <span className="text-muted-foreground/80">&middot;</span>
          <span>{pitchDuration}</span>
        </p>
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  )
}
